// extracted by mini-css-extract-plugin
module.exports = {"option":"styles-module__option___2tQZu","customRegion":"styles-module__customRegion___1RY8z","count":"styles-module__count___KJQ0l"};